module.exports = __webpack_public_path__ + "media/webfonts/fa-solid-900-0bff33a5.ttf";